// AI Generated
import { Component, Input, Output, EventEmitter, OnInit, numberAttribute } from '@angular/core';

@Component({
    selector: 'icon-button',
    templateUrl: './icon-button.html',
    standalone: false,
})
export class IconButtonComponent implements OnInit {
    @Input() faIcon: any = '';
    @Input({ transform: numberAttribute }) number: number = 0;
    @Input() positive: string = 'text-success';
    @Input() tooltip: string = '';
    @Input() negative: string = 'text-danger';
    @Input() neutral: string = 'text-primary';
    @Input() changeTextColor: boolean = true;
    @Input() disabled: boolean = false;
    @Input() monAriaLabel: string = '';
    @Input() monAriaIconText: string = '';
    @Output() callback = new EventEmitter<{ event: Event }>();

    textClass: any = {};

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.textClass = {};
        this.positive = this.positive || 'text-success';
        this.negative = this.negative || 'text-danger';
        this.neutral = this.neutral || 'text-primary';
        this.tooltip = this.tooltip || '';
        this.disabled = this.disabled || false;
        this.changeTextColor = this.changeTextColor === undefined ? true : this.changeTextColor;

        if (this.number == null) {
            this.number = 0;
        }
    }

    evaluate (change: boolean): string {
        if (!change) {
            return '';
        }
        if (this.disabled) {
            return 'text-grey';
        }
        let result = '';
        if (this.number > 0) {
            result = this.positive;
        } else if (this.number < 0) {
            result = this.negative;
        } else {
            result = this.neutral;
        }
        return result;
    }

    onCallback (event: Event) {
        if (!this.disabled) {
            this.callback.emit({ event });
        }
    }
}
